import React, {
	useEffect,
	useState
} from "react";
const {
	threeDUrl
} = window.globalConfig;
import SystemApi from "../../api/sys";
import {
	getArea
} from "../../utils/common";
import flvjs from "flv.js"
import "./index.scss";
import { PlayCircleOutlined } from "@ant-design/icons";
import { Select } from 'antd';
const { Option } = Select;
const {
	monitorUrl
} = window.globalConfig;
var channelAll = []
var channelList = []
export default () => {
	const [area, setArea] = useState({})
	const [channel, setChannel] = useState({});
	const [videoShow, setVideoShow] = useState(false);
	const [videoShowTip, setVideoShowTip] = useState(false);
	const [flvPlayerObj, setFlvPlayerObj] = useState({});
	let timer;
	useEffect(() => {
		getChannelList();
		// 在父页面的 script 中添加
		window.addEventListener('message', (event)=> {
			console.log('收到 iframe 消息:', event.data);
			setVideoShowTip(false)
			//由于三维是通过监听动画帧触发的范围判断， 所以可能会重复向父页面发送消息， 需要在父页面做判断处理
			if (event.data.type == 1 || event.data.type == 2) {
				clearTimeout(timer);
				timer = setTimeout(() => {
					setArea(event.data)
				}, 2000);
			}
		});
		return () => {
		  for (let attr in flvPlayerObj) {
		    flvPlayerObj[attr] && flvPlayerObj[attr].destroy();
		  }
		};
	}, []);
	useEffect(() => {
		if (area.type == 1) {
			//显示视频窗口
			console.log('显示视频窗口:', area);
			playVideo()
		} else if (area.type == 2) {
			//隐藏视频窗口
			console.log('隐藏视频窗口:', area);
			destroyVideo()
		}
	}, [area]);
	const getChannelList = () => {
		SystemApi.getDeviceChannelList({}).then((res) => {
			if (res.status !== "0") return
			channelAll = res.data;
			// playVideo()
			// let channe = res.data.find(item => '生化池' == item.name)

			// if (channe) {
			// 	setChannel(channe)
			// 	play(channe.id)
			// }
		});
	};
	const playVideo = () => {
		// let areas = getArea('MBR膜池')
		let areas = getArea(area.area);
		channelList = channelAll.filter(item => areas.includes(item.name))
		if (channelList.length) {
			setVideoShow(true)
			setChannel(channelList[0])
			play(channelList[0])
			
		} else {
			setVideoShowTip(true)
		}
	}
	const switchVideo = (value) => {
		let obj = channelList.find(item=>item.id==value)
		// return
		if(obj.id == channel.id) return
		
		flvPlayerObj[`flvPlayer${channel.id}`] && flvPlayerObj[`flvPlayer${channel.id}`].destroy();
		flvPlayerObj[`flvPlayer${channel.id}`] = null;
		
		setChannel(obj)
		play(obj)
	}
	const destroyVideo = () => {
		
		flvPlayerObj[`flvPlayer${channel.id}`] && flvPlayerObj[`flvPlayer${channel.id}`].destroy();
		flvPlayerObj[`flvPlayer${channel.id}`] = null;
		
		setVideoShow(false)
	}
	const play = ({id}) => {
		SystemApi.getDevicePreviewUrl({
			id
		}).then((res) => {
			if (res.status !== "0") return;
			if (flvjs.isSupported) {
				const videoElement = document.getElementById(`videoSurveillance${id}`);
				const flvPlayer = flvjs.createPlayer({
					type: "flv",
					url: `${monitorUrl}playRtsp?url=${res.data.url}`,
				});
				flvPlayer.attachMediaElement(videoElement);
				flvPlayer.load();
				videoElement.play();

				flvPlayerObj[`flvPlayer${id}`] = flvPlayer;

				setFlvPlayerObj(flvPlayerObj);

			} else {
				message.error("FLV not supported");
			}
		});
	};
	return (<div style={{display: "block",width: "100%",height: "100%",border: 0}}>
				<iframe style={{
					display: "block",
					width: "100%",
					height: "100%",
					border: 0}} src={threeDUrl}>
				</iframe> 
				{
					 videoShow && channelList.length>1 && (
						 <Select
							 style={{ width: 120 }}
							 value={channel.id}
							 className="operate-select"
							 onChange={switchVideo}
						 >
							 {channelList.map(item => {
								 return (<Option key={item.id} value={item.id}>{item.name}</Option>)
							 })}
						 </Select>
					 )
				}
				{ videoShow && ( <div className="video-content"> 
								
								<div className="video-list" key={channel.id}>
									<div className="video-item"> 
										{channel.name}
									</div>
									<video style={{width: "100%",height: "100%",objectFit: 'cover'}} 
										controls
										id={`videoSurveillance${channel.id}`}>
									</video> 
								</div> 
						</div> )
				}
				{ videoShowTip && ( <div style={{
							position: "fixed",
							width: "calc(25vw)",
							height: "calc(15vw)",
							top: '68px',
							right: '20px',
							zIndex: '9999',
							padding: '20px',
							textAlign: 'center',
							backgroundColor: '#cdcdcd'
						}}>{area.area} 暂无监控 </div> )
				} 
			</div>)
}